module.exports = __webpack_public_path__ + "static/media/books.2c4f70dc.jpg";